import { menuClasses } from '@mui/material/Menu';

export const MENU_PAPER_STYLES = {
  borderRadius: '16px',
  boxShadow:
    '0px 0px 1px 1px rgba(26, 27, 35, 0.04), 0px 16px 16px 0px rgba(26, 27, 35, 0.06), 0px 16px 16px -16px rgba(26, 27, 35, 0.24)',
};

export const MENU_LIST_STYLES = {
  margin: 0,
  padding: 0,
};

export const menuClassStyles = {
  [`.${menuClasses.paper}`]: MENU_PAPER_STYLES,
  [`.${menuClasses.list}`]: MENU_LIST_STYLES,
};
